import { createContext } from 'react';

import type { PlaceMock } from './mock/types';

export type GetGoogleMapsApi = () =>
  | { type: 'production'; maps: typeof google.maps }
  // `PlaceMock`s are kept in a global variable rather than using a `setState`
  // hook, so the context will not re-render when the mocks change. For that
  // reason, we must define them like a ref.
  | { type: 'mock'; mocks: { current: { mockedPlaces: PlaceMock[] } } }
  | null;

export const GoogleMapsApiContext = createContext<GetGoogleMapsApi>(() => null);
